import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { CheckLogin } from '@shared/store/auth/auth.actions';
import { environment } from '@env/environment';

@Component({
    selector: 'app-remote-auth',
    template: `
    <div class="auth-loading">
      <div class="spinner"></div>
      <p>{{ statusMessage }}</p>
    </div>
  `,
    styles: [`
    .auth-loading {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100vh;
      font-size: 18px;
      color: #333;
    }
    .spinner {
      border: 4px solid #f3f3f3;
      border-top: 4px solid #3498db;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      animation: spin 1s linear infinite;
      margin-bottom: 20px;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `],
    standalone: false
})
export class RemoteAuthComponent implements OnInit {
  statusMessage = 'Authenticating...';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.processRemoteAuth();
  }

  private processRemoteAuth(): void {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];

      if (!code) {
        console.error('No authentication code found in URL');
        this.statusMessage = 'Authentication failed - No code provided';
        setTimeout(() => this.router.navigateByUrl('/login'), 2000);
        return;
      }

      this.exchangeCodeForToken(code);
    });
  }

  private exchangeCodeForToken(code: string): void {
    this.statusMessage = 'Validating authentication...';

    const portalUrl = environment.adminPanelUrl || 'http://localhost:3000';

    this.http.get<any>(
      `${portalUrl}/api/remoteconnect/generate-auth-code?code=${code}`
    ).subscribe({
      next: (response) => {
        if (!response || !response.jwt) {
          console.error('Invalid authentication response');
          this.statusMessage = 'Invalid authentication response';
          setTimeout(() => this.router.navigateByUrl('/login'), 2000);
          return;
        }

        localStorage.setItem('jwt', response.jwt);
        localStorage.setItem('refreshToken', response.refreshToken);
        localStorage.setItem('userDetail', JSON.stringify(response.userDetails));
        localStorage.setItem('companySettings', JSON.stringify(response.companySettings));

        localStorage.removeItem('filter');
        localStorage.setItem('filter', JSON.stringify({ isCompany: false, isSection: true }));

        localStorage.removeItem('temp2FAToken');
        localStorage.removeItem('requires2FA');

        localStorage.setItem('remote_auth', 'true');

        this.statusMessage = 'Authentication successful! Loading...';

        this.store.dispatch(new CheckLogin());

        window.history.replaceState({}, document.title, '/dashboard');

        setTimeout(() => {
          this.router.navigateByUrl('/dashboard');
        }, 500);
      },
      error: (error: HttpErrorResponse) => {
        console.error('Error exchanging code for token:', error);

        if (error.status === 401) {
          this.statusMessage = 'Authentication code expired or invalid';
        } else if (error.status === 0) {
          this.statusMessage = 'Cannot connect to portal server';
        } else {
          this.statusMessage = 'Authentication failed';
        }

        setTimeout(() => this.router.navigateByUrl('/login'), 2000);
      }
    });
  }
}
